import { defineMessages, useIntl } from 'react-intl'
import styled, { css } from 'styled-components'

import { BADGE_ASSISTANT, BADGE_MASTER } from '@constants'

import assistant_big_badge from '@assets/img/badges/assistant_big.svg'
import assistant_small_badge from '@assets/img/badges/assistant_small.svg'
import master_big_badge from '@assets/img/badges/master_big.svg'
import master_small_badge from '@assets/img/badges/master_small.svg'

const messages = defineMessages({
  masterBadge: {
    id: 'badges.master',
    defaultMessage: 'Master',
  },
  assistantBadge: {
    id: 'badges.assistant',
    defaultMessage: 'Assistant',
  },
})

const UserBadgeWrapper = styled.span<{ $size: 'small' | 'big' }>`
  ${({ $size }) =>
    $size === 'small'
      ? css`
          position: relative;
          padding-right: 5px;
          display: inline-block;
          vertical-align: middle;
          line-height: 1;
        `
      : css`
          display: block;
        `};
`

const badges = {
  source: {
    small: {
      [BADGE_ASSISTANT]: assistant_small_badge,
      [BADGE_MASTER]: master_small_badge,
    },
    big: {
      [BADGE_ASSISTANT]: assistant_big_badge,
      [BADGE_MASTER]: master_big_badge,
    },
  },
  alt: {
    [BADGE_ASSISTANT]: messages.assistantBadge,
    [BADGE_MASTER]: messages.masterBadge,
  },
}

export const BADGES_LIST = [BADGE_MASTER, BADGE_ASSISTANT] as const

interface UserBadgeProps {
  badge?: (typeof BADGES_LIST)[number] | null
  size?: 'small' | 'big'
}

export function UserBadge({ badge, size = 'small' }: UserBadgeProps) {
  const { formatMessage } = useIntl()

  if (badge == null) {
    return null
  }

  return (
    <UserBadgeWrapper $size={size}>
      <img src={badges.source[size][badge]} alt={formatMessage(badges.alt[badge])} />
    </UserBadgeWrapper>
  )
}
